Controller = App.loadClass 'core::Angular/Controller'

class exports.CustomersController extends Controller
    constructor: (@scope, @transitions, @state, @service, @filterService, @loading, @ngModal) ->
        super

        @scope.title = 'Customers'
        @scope.fullpage = true
        @scope.alwaysReenable = true

        @scope.$on 'Customers:run', (_, filters) =>
            @filters = filters
            @refresh filters

        @scope.resize = 0

        @scope.$emit 'Customers:init'

        unregisterPdfProcessingHandler = Socket.register 'pdfProcessingUpdate', (data) =>
            return if @filters.years[0].key is not data.year
            return if data.customer_id
            program = @programs.find((p) => p.program_id is data.program_id and p.crop_id is data.crop_id)
            return if not program
            program.processing = data.processing

        @scope.$on '$destroy', =>
            unregisterPdfProcessingHandler()

    generatePDF: (program) ->
        return unless program?
        url = '/backend/portal/sustainability-programs/gen-program-pdf'
        @service.generatePDF url, program.year, program.crop_id, program.program_id
        @ngModal.launchReportGeneratingDialog()

    launchModal: (program) ->
        @ngModal.launchSusCustomersDialog(program, @susCustomers)

    refresh: (filters) ->
        @service.getSusCustomers().then (response) =>
            @susCustomers = response
        @service.getPrograms(filters).then (response) =>
            @programs = response.programs
            @scope.resize += 1
